// Google Analytics Utility
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics Measurement ID

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Initialize Google Analytics
export const initGA = () => {
  // Check if gtag is available
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false, // We'll send page views manually
    });
    console.log('Google Analytics initialized');
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
    console.log('Page view tracked:', path);
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
    console.log('Event tracked:', { action, category, label, value });
  }
};

// E-commerce tracking
export const trackProductView = (product) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_item', {
      currency: 'INR',
      value: product.price,
      items: [{
        item_id: product._id,
        item_name: product.name,
        item_category: product.category?.name || 'Uncategorized',
        price: product.price,
        quantity: 1,
      }],
    });
    console.log('Product view tracked:', product.name);
  }
};

export const trackAddToCart = (product, quantity = 1) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: 'INR',
      value: product.price * quantity,
      items: [{
        item_id: product._id,
        item_name: product.name,
        item_category: product.category?.name || 'Uncategorized',
        price: product.price,
        quantity: quantity,
      }],
    });
    console.log('Add to cart tracked:', product.name, 'x', quantity);
  }
};

export const trackRemoveFromCart = (product, quantity = 1) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'remove_from_cart', {
      currency: 'INR',
      value: product.price * quantity,
      items: [{
        item_id: product._id,
        item_name: product.name,
        item_category: product.category?.name || 'Uncategorized',
        price: product.price,
        quantity: quantity,
      }],
    });
    console.log('Remove from cart tracked:', product.name);
  }
};

export const trackBeginCheckout = (cart, totalPrice) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: 'INR',
      value: totalPrice,
      items: cart.map(item => ({
        item_id: item._id,
        item_name: item.name,
        item_category: item.category?.name || 'Uncategorized',
        price: item.price,
        quantity: item.quantity,
      })),
    });
    console.log('Begin checkout tracked');
  }
};

export const trackPurchase = (orderId, cart, totalPrice) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: orderId,
      currency: 'INR',
      value: totalPrice,
      items: cart.map(item => ({
        item_id: item._id,
        item_name: item.name,
        item_category: item.category?.name || 'Uncategorized',
        price: item.price,
        quantity: item.quantity,
      })),
    });
    console.log('Purchase tracked:', orderId);
  }
};

export const trackSearch = (searchTerm) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'search', {
      search_term: searchTerm,
    });
    console.log('Search tracked:', searchTerm);
  }
};

export const trackRepairRequest = (serviceType) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'repair_request', {
      event_category: 'Service',
      event_label: serviceType,
    });
    console.log('Repair request tracked:', serviceType);
  }
};

export const trackCustomDesign = (designName) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'custom_design', {
      event_category: 'Custom Studio',
      event_label: designName,
    });
    console.log('Custom design tracked:', designName);
  }
};

export const trackUserSignup = (method = 'email') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'sign_up', {
      method: method,
    });
    console.log('User signup tracked:', method);
  }
};

export const trackUserLogin = (method = 'email') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'login', {
      method: method,
    });
    console.log('User login tracked:', method);
  }
};
